/**
 * Choose an estimate mode: quick or detailed
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page, PageHeader } from '../ui';
import EstimateModeCards from './EstimateModeCards';
import { getEstimateCopy } from './copy';
import { useLanguage } from '../../utils/LanguageContext';

const EstimateStartPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = getEstimateCopy(language);

  return (
    <Page>
      <PageHeader title={t.startTitle} subtitle={t.startSubtitle} onBack={() => navigate('/app')} backLabel={t.back} />
      <EstimateModeCards />
    </Page>
  );
};

export default EstimateStartPage;
